export default __webpack_public_path__ + "static/media/mobilityscorePro.ee24b0d0.svg";